import React from 'react';
import './style.css';

const Space = ({ joinHandler }) => {
  return (
    <div className='wrapper-space'>
      <div className='purple-moons'></div>
      <div className='astro'></div>
      <div className='ufo'></div>
      <div className='space-expedition-mob'></div>
      <span className='heading'>
        Why <span className='heading-color'>Space Education</span> For Kids?
      </span>
      <div className='space-info-div'>
        <div className='space-info'>
          <span className='space-info-text'>
            "Your child learn creativity, imagination and the ability to
            question"
          </span>
          <span className='space-info-text'>
            {' '}
            Space fascinates kids. Their curious minds are filled with questions
            on Gravity of Black-Holes, Heat of Sun and Aliens on Mars.
          </span>

          <span className='space-info-text'>
            {' '}
            As educators and parents its our responsibility to provide a clear
            path to nurture this curiosity.{' '}
          </span>
          <span className='space-info-text'>
            And that is what we do at Kalam Labs.
          </span>
        </div>
        <div className='space-info-pic'></div>
      </div>
      <div className='space-btn-div'>
        <span className='space-btn-text'>
          Want your child to be a part of this?
        </span>
        <span className='space-btn' onClick={joinHandler}>
          Join now
        </span>
      </div>
      <div className='learn-div'>
        <span className='learn-heading'>
          Your Child Will{' '}
          <span className='learn-heading-color'>{'  '} Learn</span>
        </span>
        <div className='learn-logos'>
          <div className='logo'>
            <div
              className='logo-pic'
              style={{
                background: `url(${require('../../assets/imagination.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='logo-text'>Imagination</span>
          </div>
          <div className='logo'>
            <div
              className='logo-pic'
              style={{
                background: `url(${require('../../assets/ambition.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='logo-text'>Ambition</span>
          </div>
          <div className='logo'>
            <div className='logo-pic'></div>
            <span className='logo-text'>Creativity</span>
          </div>
          <div className='logo'>
            <div
              className='logo-pic'
              style={{
                background: `url(${require('../../assets/curiosity.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='logo-text'>Curiosity</span>
          </div>
        </div>
        <div className='mobile-btn-div'>
          <span className='mobile-btn-div-text'>
            Want your child to be a <br /> part of this?
          </span>
          <span className='mobile-btn' onClick={joinHandler}>
            Join now
          </span>
        </div>
      </div>
    </div>
  );
};

export default Space;
